import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { WhySection } from './components/WhySection';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1002798425440252');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="nwc23tmizxws">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1002798425440252&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="nur7k407oeyx" />
      </noscript>
      <div className="flex min-h-screen w-full flex-col items-center overflow-x-hidden bg-cream" data-id="element-2" data-mp="34nbhsjeuzx5">
        <main className="w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="3ucjcjtti8btq">
          <Hero data-id="element-4" data-mp="d4xmd6hz3v95" />
          <WhySection data-id="element-5" data-mp="d3cr1enu48a8" />
          <SystemOverview data-id="element-6" data-mp="d2l8p5j9071w" />
          <Modules data-id="element-7" data-mp="85uj9rljzz3t" />
          <LookInside data-id="element-8" data-mp="85bdf996h165" />
          <Bonuses data-id="element-9" data-mp="86w3alkjrvxo" />
          <Differentiators data-id="element-10" data-mp="83i3nl39q0tx" />
          <Offer data-id="element-11" data-mp="3gl4t5lvoq8m5" />
          <Guarantee data-id="element-12" data-mp="3gkla21uate6j" />
          <Testimonials data-id="element-13" data-mp="3gm66jx06b771" />
          <FAQ data-id="element-14" data-mp="3gja7248ogagh" />
          <FinalCTA data-id="element-15" data-mp="3bmbdpnwu87jc" />
          <Footer data-id="element-16" data-mp="3bmtij8xkfu2v" />
        </main>
      </div>
      <SalesPopup data-id="element-17" data-mp="3bnus18yxo8ih" />
    </>;
}